import {useBreakpointDown} from '@travel-frontend/core';

export const useFloatingActionButtonMargin = (): number => {
  const smDown = useBreakpointDown('sm');
  return smDown ? 16 : 24;
};
